import { GET_PACKING_TYPES } from "../../type/packingType";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const packingTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PACKING_TYPES:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default packingTypeReducer;
